export default function moveToSearchLocation(place, map) {
  if ((/street-address/g).test(place.adr_address)) {
    map.setCenter(place.geometry.location)
    map.setZoom(19)
  } else {
    map.fitBounds(place.geometry.viewport)
    map.setZoom(12)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map/moveToSearchLocation.js